document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        var obfButton = e.target.closest('.obf');

        if (obfButton) {
            var base64Url = obfButton.getAttribute('rel');

            var decodedUrl = atob(base64Url);

            window.open(decodedUrl, '_blank');
        }
    });
});
